<template>
  <div>
    <div class="h-100 bg-light">
      <div class="d-flex h-100 justify-content-center align-items-center">
        <b-col md="8" class="mx-auto app-login-box d-block">
          <div class="d-flex w-auto justify-content-center">
            <img
              src="@/assets/images/logo-login.png"
              height="100px"
              class="d-block img-fluid logo-img"
            />
          </div>
          <div class="mx-auto mb-3" />

          <form
            action=""
            method="POST"
            @submit.prevent="login"
            v-on:keyup.enter="login"
          >
            <div class="modal-dialog w-100 mx-auto">
              <div class="modal-content">
                <div class="modal-body">
                  <div class="h5 modal-title text-center">
                    <h4 class="mt-2">
                      <span>Please sign in to your account.</span>
                    </h4>
                  </div>
                  <b-form-group id="username" label-for="username">
                    <b-form-input
                      id="username"
                      type="text"
                      required
                      placeholder="Enter username..."
                      v-model="username"
                      :disabled="loading || termsDialog"
                    >
                    </b-form-input>
                  </b-form-group>
                  <b-form-group id="password" label-for="password">
                    <b-form-input
                      id="password"
                      type="password"
                      required
                      placeholder="Enter password..."
                      v-model="password"
                      :disabled="loading || termsDialog"
                    >
                    </b-form-input>
                  </b-form-group>

                  <div class="form-group">
                    <div v-if="error" class="alert alert-danger" role="alert">
                      {{ error }}
                    </div>
                  </div>
                </div>
                <div class="modal-footer clearfix">
                  <div class="float-left">
                    <a
                      v-if="!termsDialog"
                      href="/#/password-recovery"
                      class="btn-lg btn btn-link"
                      >Recover Password</a
                    >
                  </div>
                  <div class="float-right">
                    <v-btn
                      color="primary"
                      class="text-unset"
                      sm
                      @click="login"
                      :disabled="loading || termsDialog"
                      :loading="loading"
                      >Login to Dashboard</v-btn
                    >
                  </div>
                </div>
              </div>
            </div>
          </form>
          <div class="text-center opacity-8 mt-3">
            Copyright &copy; Hotelium 2026
          </div>
        </b-col>
      </div>
    </div>

    <v-dialog v-model="termsDialog" persistent max-width="800">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          Terms &amp; Conditions
        </v-card-title>
        <v-card-text>
          <div class="mb-4">
            <div>
              Please open the document at the following link:
              <a
                target="_blank"
                href="https://panel.hotelium.io/static/materials/TERMS%20AND%20CONDITIONS%202026.pdf"
                >Terms and Conditions
                <svg
                  aria-hidden="true"
                  focusable="false"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 384 512"
                  class="svg-inline--fa fa-file-alt fa-w-12"
                >
                  <path
                    data-v-e599b3b6=""
                    fill="currentColor"
                    d="M224 136V0H24C10.7 0 0 10.7 0 24v464c0 13.3 10.7 24 24 24h336c13.3 0 24-10.7 24-24V160H248c-13.2 0-24-10.8-24-24zm64 236c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-64c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12v8zm0-72v8c0 6.6-5.4 12-12 12H108c-6.6 0-12-5.4-12-12v-8c0-6.6 5.4-12 12-12h168c6.6 0 12 5.4 12 12zm96-114.1v6.1H256V0h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z"
                    class=""
                  ></path>
                </svg>
              </a>
              and read them carefully before proceeding.
            </div>
          </div>
          <div v-if="termsError" class="alert alert-danger" role="alert">
            {{ termsError }}
          </div>
          <v-checkbox
            v-model="termsAgree"
            label="I have read and agree to the Terms and Conditions."
            :disabled="termsLoading"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            color="primary"
            class="text-unset"
            @click="confirmTerms"
            :disabled="!termsAgree || termsLoading"
            :loading="termsLoading"
            >Confirm</v-btn
          >
          <v-spacer />
          <v-btn
            color="error"
            class="text-unset"
            @click="logout"
            :disabled="termsLoading"
            >Logout</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>


<script>
import gql from "graphql-tag";
import { onLogin, onLogout } from "../../vue-apollo.js";
export default {
  name: "Login",
  data() {
    return {
      username: "",
      password: "",
      loading: false,
      message: "",
      token: "",
      terms: false,
      termsDialog: false,
      termsAgree: false,
      termsLoading: false,
      termsError: null,
      error: null,
    };
  },
  created() {
    if (sessionStorage.getItem("terms-pending") === "1") {
      this.openTermsDialog();
      return;
    }
    if (this.$route.params.uid) {
      this.axios
        .get(
          "/admin-api/redirlogin?access_token=" +
            localStorage.getItem("apollo-token") +
            "&id=" +
            this.$route.params.uid
        )
        .then((data) => {
          sessionStorage.setItem("apollo-token", data.data.token);
          localStorage.setItem("mimic-token", data.data.token);
        });
      sessionStorage.setItem("afterLogin", "1");
      this.$router.push("/");
    }
    if (localStorage.getItem("apollo-token") !== null) {
      sessionStorage.setItem("afterLogin", "1");
      this.$router.push("/");
    }
  },
  methods: {
    openTermsDialog() {
      this.termsError = null;
      this.termsAgree = false;
      this.termsDialog = true;
    },
    closeTermsDialog() {
      this.termsError = null;
      this.termsAgree = false;
      this.termsDialog = false;
    },
    async confirmTerms() {
      if (!this.termsAgree || this.termsLoading) {
        return;
      }
      this.termsError = null;
      this.termsLoading = true;
      try {
        this.$apollo
          .mutate({
            mutation: gql`
              mutation ($confirmation: Int!) {
                confirmTerms(confirmation: $confirmation)
              }
            `,
            variables: {
              confirmation: 1,
            },
          })
          .then((data) => {
            if (data.data.confirmTerms === true) {
              window.location.href = "/";
            } else {
              this.logout();
            }
          });
      } catch (e) {
        this.termsError = e && e.message ? e.message : String(e);
      } finally {
        this.termsLoading = false;
      }
    },
    async logout() {
      if (this.termsLoading) {
        return;
      }
      try {
        await onLogout(this.$apollo.provider.defaultClient);
      } catch (e) {
        console.log("error on logut", e);
      }
      sessionStorage.removeItem("apollo-token");
      sessionStorage.removeItem("afterLogin");
      sessionStorage.removeItem("terms-pending");
      localStorage.removeItem("apollo-token");
      localStorage.removeItem("mimic-token");
      this.closeTermsDialog();
      window.location.href = "/#";
    },
    login() {
      if (this.loading || this.termsDialog) {
        return;
      }
      this.error = null;
      this.loading = true;
      this.$apollo
        .mutate({
          mutation: gql`
            mutation ($data: AuthenticateInput!) {
              authenticate(input: $data) {
                error
                token
                user {
                  id
                  username
                  email
                  firstName
                  terms
                }
              }
            }
          `,
          variables: {
            data: {
              username: this.username,
              password: this.password,
            },
          },
        })
        .then((data) => {
          if (data.data.authenticate.error) {
            this.error = data.data.authenticate.error;
            this.username = "";
            this.password = "";
          } else {
            onLogin(
              this.$apollo.provider.defaultClient,
              data.data.authenticate.token
            );
            if (
              data.data.authenticate.user &&
              data.data.authenticate.user.terms == null
            ) {
              sessionStorage.setItem("terms-pending", "1");
              this.openTermsDialog();
              return;
            }
            this.$router.push("/");
          }
        })
        .catch((error) => {
          this.error = error;
          this.username = "";
          this.password = "";
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.centered {
  margin: auto;
}

.logo-img {
  max-width: 175px;
  max-height: 100px;
}
</style>
